import type { EndsHighlightedReview } from '@ballerine/common';

import { Star } from '../../../../../common/icons/lucide-adapter';
import { isAbsoluteHttpUrl } from './utils';

type HighlightedReviewCardProps = {
  review: EndsHighlightedReview;
};

export const HighlightedReviewCard = ({ review }: HighlightedReviewCardProps) => {
  const { name, stars, date, quote, permalink } = review;
  const hasLink = permalink != null && isAbsoluteHttpUrl(permalink);

  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-gray-200 p-5">
      <h4 className="text-sm font-semibold text-slate-900">Highlighted Review</h4>
      <div className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
        {name && <span className="font-semibold text-slate-900">{name}</span>}
        {stars != null && (
          <span className="inline-flex items-center gap-1">
            <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
            {stars} star
          </span>
        )}
        {date && <span>&bull; {date}</span>}
      </div>
      {quote && <p className="text-sm leading-relaxed text-slate-700">{quote}</p>}
      {hasLink && (
        <a
          href={permalink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-medium text-blue-600 underline underline-offset-2 hover:text-blue-800"
        >
          View
        </a>
      )}
    </div>
  );
};
